export const employmentType = [
  { id: "EMPLOYEE", name: "screening.dropdowns.employment.employee" },
  { id: "SELF_EMPLOYED", name: "screening.dropdowns.employment.self_employed" },
  { id: "PENSION", name: "screening.dropdowns.employment.pension" },
];

export const amountOfRenters = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5" },
];

export const amountOfSigners = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5" },
];

export const pets = [
  { id: 1, name: "screening.dropdowns.pets.yes" },
  { id: 2, name: "screening.dropdowns.pets.no" },
];

export const guarantor = [
  { id: 1, name: "screening.dropdowns.guarantor.yes" },
  { id: 2, name: "screening.dropdowns.guarantor.no" },
];

export const amountOfGuarantors = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
];
